import { FunctionComponent } from 'react'
import Module, {
  AllowedThemes,
  ModuleContainer,
  ModuleHeadline,
  themesMap,
} from '@components/undock/modules'
import {
  Container,
  ContentWrapper,
  TestimonialsWrapper,
} from '@components/undock/modules/testimonials/style'
import { TestimonialsModuleI } from '@lib/contentful/entries'

interface TestimonialsModulePropsI extends TestimonialsModuleI {}

const TestimonialsModule: FunctionComponent<TestimonialsModulePropsI> = ({
  headline = null,
  id = 'NO_ID_PROVIDED',
  label = null,
  subHeadline = null,
  themeName = 'light',
}) => {
  return (
    <Module id={id} theme={themesMap[themeName]}>
      <ModuleContainer>
        {(headline || label || subHeadline) && (
          <ContentWrapper>
            {headline && <ModuleHeadline>{headline}</ModuleHeadline>}
          </ContentWrapper>
        )}
        <TestimonialsWrapper>[Testimonials placeholder]</TestimonialsWrapper>
      </ModuleContainer>
    </Module>
  )
}

export default TestimonialsModule
